import React, { useEffect, useState } from 'react'
import styles from './Phase1.module.css'

import IconVolume from '../../../../../assets/icons/IconVolume'
import IconBack from '../../../../../assets/icons/IconBack'
import IconForward from '../../../../../assets/icons/IconForward'

import Image from '../../components/Image/Image'
import {
    getSoundDownloadUrl
} from '../../components/Sound/Sound'

const Phase1 = ({
    words
}) => {
    console.log(words);
    const [currPosition, setCurrPosition] = useState(0)
    const [currPlayingSound, setCurrPlayingSound] = useState(0)

    useEffect(() => {
        setTimeout(() => {
            
        }, 500);
    }, [])

    

    return (
        <div className={styles.container}>
            <div className={styles.imageContainer}>
                <Image imagePath={words[currPosition].img_path} className={styles.image} />

            </div>
            <div className={styles.nameContainer}>
                <p className={styles.nameHint}>Name</p>
                <p className={styles.name}>{words[currPosition].eng}</p>
                <IconVolume size={24} />
            </div>
            <div className={styles.nameContainer}>
                <p className={styles.nameHint}>Sound</p>
                <p className={styles.name}>{words[currPosition].pron}</p>
                <IconVolume size={24} />
            </div>
            <div className={styles.bottomNavigation}>
                {currPosition <= 0 ?
                    <div style={{ width: '40px' }} /> : <IconBack
                        size={24}
                        className={styles.backButton}
                        color={'black'}
                        onClick={() => setCurrPosition(i => i - 1)} />}
                <p className={styles.bottomNavigationTitle}>{(currPosition + 1) + '/' + (words.length)}</p>
                {currPosition + 1 >= words.length ?
                    <div style={{ width: '40px' }} /> : <IconForward
                        size={24}
                        color={'white'}
                        className={styles.nextButton}
                        onClick={() => setCurrPosition(i => i + 1)} />}
            </div>
        </div>
    )
}

export default Phase1
